module.exports = __webpack_public_path__ + "media/Do.bc9270b6.mp3";